var _circle, _g, _circle2, _g2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconeVacinacao = function SvgIconeVacinacao(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_d_14652_31407)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16,
    fill: "#FCCE74"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14652_31407",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 24,
    height: 24
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 12,
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14652_31407)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_14652_31407)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1697 19.4049C25.0008 18.5738 25.0008 17.7418 24.1697 16.9098L17.931 10.6711C17.099 9.83906 16.2678 9.83906 15.4358 10.6711L14.812 11.2949L12.4969 9H10L13.5627 12.5424L12.9398 13.1662C12.1078 13.9982 12.1078 14.8302 12.9398 15.6622C13.7639 16.4867 14.8033 17.526 15.8194 18.5419L15.8218 18.5444L15.8287 18.5512C17.1699 19.8923 18.4692 21.1915 19.1776 21.9009C20.0096 22.7329 20.8417 22.7329 21.6737 21.9009L22.2974 21.2771L23.545 20.0296L24.1697 19.4049ZM16.6785 10.9538L23.8347 18.1092L20.5457 21.3991L18.8646 19.718L19.8023 18.7811C20.2143 18.362 20.2143 17.9465 19.8023 17.5336C19.3894 17.1215 18.9738 17.1215 18.5539 17.5336L17.6358 18.4516L16.4071 17.1852L17.3063 16.286C17.7227 15.8704 17.7227 15.454 17.3063 15.0384C16.8907 14.622 16.4743 14.622 16.0587 15.0384L15.187 15.9102L13.4545 14.1778L16.6785 10.9538Z",
    fill: "#FCCE74"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1697 16.9098C25.0008 17.7418 25.0008 18.5738 24.1697 19.4049L23.545 20.0296L22.2974 21.2771L21.6737 21.9009C20.8417 22.7329 20.0096 22.7329 19.1776 21.9009C18.468 21.1903 17.1654 19.8879 15.8218 18.5444C14.8049 17.5276 13.7646 16.4874 12.9398 15.6622C12.1078 14.8302 12.1078 13.9982 12.9398 13.1662L13.5627 12.5424L10 9H12.4969L14.812 11.2949L15.4358 10.6711C16.2678 9.83906 17.099 9.83906 17.931 10.6711L24.1697 16.9098Z",
    fill: "#FCCE74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.5001C14.6946 14.2825 13.9906 15.6549 14.2847 16.6842L20.3135 21.5755L23.8427 18.0463L19 13.0001C19 13.5001 18.1385 14.8565 16 14.5001Z",
    fill: "#FFEED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7153 14.316C15.9812 15.4171 14.2059 15.4707 14.5 16.5001L20.3135 21.5753L23.8427 18.0461L19 12.9999C19 12.9999 17.7153 12.816 16.7153 14.316Z",
    fill: "#FFEED6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1697 19.4049C25.0008 18.5738 25.0008 17.7418 24.1697 16.9098L17.931 10.6711C17.099 9.83906 16.2678 9.83906 15.4358 10.6711L14.812 11.2949L12.4969 9H10L13.5627 12.5424L12.9398 13.1662C12.1078 13.9982 12.1078 14.8302 12.9398 15.6622C13.7639 16.4867 14.8033 17.526 15.8194 18.5419L15.8218 18.5444L15.8287 18.5512C17.1699 19.8923 18.4692 21.1915 19.1776 21.9009C20.0096 22.7329 20.8417 22.7329 21.6737 21.9009L22.2974 21.2771L23.545 20.0296L24.1697 19.4049ZM16.6785 10.9538L23.8347 18.1092L20.5457 21.3991L18.8646 19.718L19.8023 18.7811C20.2143 18.362 20.2143 17.9465 19.8023 17.5336C19.3894 17.1215 18.9738 17.1215 18.5539 17.5336L17.6358 18.4516L16.4071 17.1852L17.3063 16.286C17.7227 15.8704 17.7227 15.454 17.3063 15.0384C16.8907 14.622 16.4743 14.622 16.0587 15.0384L15.187 15.9102L13.4545 14.1778L16.6785 10.9538Z",
    fill: "#B58B00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_14652_31407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7923 21.2771L23.5448 20.0296L22.2972 21.2771L23.5448 22.5247L22.2972 23.7723C21.8808 24.1887 21.8808 24.6051 22.2972 25.0198C22.7128 25.4363 23.1292 25.4363 23.5448 25.0198L27.2883 21.2771C27.7039 20.8607 27.7039 20.4451 27.2883 20.0296C26.8719 19.6131 26.4563 19.6131 26.0408 20.0296L24.7923 21.2771Z",
    fill: "#866600"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_14652_31407)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0506 13.8793C10.1049 13.8011 10.2136 13.775 10.2951 13.8271C10.3155 13.8402 10.3359 13.8597 10.3495 13.8793C10.4446 14.0162 10.5464 14.1662 10.6619 14.3292C11.1985 15.0856 12 16.2201 12 16.8721C12 17.3481 11.7963 17.7784 11.4702 18.0914C11.1442 18.4044 10.6959 18.6 10.2 18.6C9.70418 18.6 9.25587 18.4044 8.92984 18.0979C8.6038 17.785 8.40002 17.3546 8.40002 16.8786C8.40002 16.2266 9.20153 15.0856 9.73814 14.3292C9.8604 14.1597 9.96229 14.0162 10.0506 13.8793ZM11.2285 16.7334C10.9716 16.7334 10.9716 16.9999 10.9716 16.9999C10.9716 17.2883 10.7463 17.5336 10.4571 17.5336C10.4571 17.5336 10.1999 17.5349 10.1999 17.8008C10.1999 18.0666 10.4571 18.0666 10.4571 18.0666C11.0251 18.0666 11.4857 17.589 11.4857 16.9999C11.4857 16.9999 11.4854 16.7334 11.2285 16.7334Z",
    fill: "#FFEED6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14652_31407",
    x: 0.888889,
    y: 0.444444,
    width: 34.2222,
    height: 34.2222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.555556
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.555556
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.607843 0 0 0 0 0.466667 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31407"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31407",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_14652_31407",
    x: 8.94965,
    y: 8.47482,
    width: 16.8937,
    height: 15.6256,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.525176
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.525176
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.835294 0 0 0 0 0.643137 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31407"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31407",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_14652_31407",
    x: 20.9345,
    y: 19.1921,
    width: 7.71582,
    height: 7.71564,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.525176
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.525176
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.607843 0 0 0 0 0.466667 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31407"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31407",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_14652_31407",
    x: 7.34967,
    y: 13.2748,
    width: 5.70068,
    height: 6.9007,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.525176
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.525176
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.835294 0 0 0 0 0.643137 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31407"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31407",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconeVacinacao, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icone-vacinacao.e2936bc2.svg";
export { ForwardRef as ReactComponent };